var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBiography(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 22.5H10.5V21H4.5V3H16.5V10.5H18V3C18 2.17275 17.3273 1.5 16.5 1.5H4.5C3.67275 1.5 3 2.17275 3 3V21C3 21.8272 3.67275 22.5 4.5 22.5ZM15 4.5H6V6H15V4.5ZM10.5 10.5H6V12H10.5V10.5ZM6 7.5H15V9H6V7.5ZM10.5 18H6V19.5H10.5V18ZM15.75 18.75C14.5072 18.75 13.5 19.7572 13.5 21V22.5H15V21C15 20.586 15.336 20.25 15.75 20.25H20.25C20.664 20.25 21 20.586 21 21V22.5H22.5V21C22.5 19.7572 21.4928 18.75 20.25 18.75H15.75ZM19.5 15C19.5 14.1713 18.828 13.5 18 13.5C17.1713 13.5 16.5 14.1713 16.5 15C16.5 15.8287 17.1713 16.5 18 16.5C18.828 16.5 19.5 15.8287 19.5 15ZM21 15C21 16.6567 19.6567 18 18 18C16.3433 18 15 16.6567 15 15C15 13.3433 16.3433 12 18 12C19.6567 12 21 13.3433 21 15Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiography);
export default __webpack_public_path__ + "static/media/biography.46240debfff2da787922970a1087f7a2.svg";
export { ForwardRef as ReactComponent };